import { __assign } from '../node_modules/tslib/tslib.es6.js';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import React from 'react';

/**
 * Adds light and dark theme color options if they are missing
 *
 * https://mui.com/material-ui/customization/palette/#generate-tokens-using-augmentcolor-utility
 */
var getAugmentedColorOption = function (theme, colorOption) {
    if (colorOption && 'main' in colorOption) {
        return theme.palette.augmentColor({
            color: {
                main: colorOption.main,
                light: colorOption.light,
                dark: colorOption.dark,
            },
        });
    }
    return colorOption;
};
var mergeThemeOptions = function (innerThemeOptions) {
    return function (outerTheme) {
        var _a;
        var theme = (outerTheme === null || outerTheme === void 0 ? void 0 : outerTheme.palette) ? outerTheme : createTheme();
        if (!innerThemeOptions) {
            return theme;
        }
        var primary = getAugmentedColorOption(theme, (_a = innerThemeOptions === null || innerThemeOptions === void 0 ? void 0 : innerThemeOptions.palette) === null || _a === void 0 ? void 0 : _a.primary);
        var augmentedInnerTheme = innerThemeOptions && __assign(__assign({}, innerThemeOptions), { palette: __assign(__assign({}, innerThemeOptions.palette), { primary: primary }) });
        return createTheme(deepmerge(theme, augmentedInnerTheme));
    };
};
var CustomThemeProvider = function (props) {
    return React.createElement(ThemeProvider, { theme: mergeThemeOptions(props.themeOptions) }, props.children);
};

export { CustomThemeProvider, mergeThemeOptions };
//# sourceMappingURL=customTheme.js.map
